import React from 'react';
import maskHeader from "../../../src/assets/img/header-mask.webp";
import { U } from '../../assets/img/svg/details';

interface Breadcrumb {
    slug: string;
    name: string;
}

interface HeaderProps {
    title: string;
    breadcrumb: Breadcrumb[];
    image?: string;
}

const Header: React.FC<HeaderProps> = ({ breadcrumb, title, image }) => {
    return (
        <header>
            <div className="bg-main-blue flex flex-col relative max-w-[1920px] mx-auto w-full md:h-[200px] lg:h-[250px] 2xl:h-[300px] overflow-hidden banner-mask z-10"
                style={{
                    maskImage: `url(${maskHeader})`,
                    WebkitMaskImage: `url(${maskHeader})`,
                    maskSize: '100% 100%',
                    WebkitMaskSize: '100% 100%',
                    maskPosition: 'center bottom',
                    WebkitMaskPosition: 'center bottom',
                }}
            >
                
                {image ? <img src={image} alt="Imagem de Fundo" className='w-full h-full object-cover max-h-[80px] md:max-h-none order-2' /> : ''}
                <U className="absolute md:-top-14 lg:-top-36 right-4 md:right-20 2xl:right-60 h-[150px] md:h-[300px] lg:h-[550px] w-[150px] md:w-[300px] lg:w-[550px] object-contain rotate-12 -z-10" />

                <div className="md:absolute left-0 top-0 w-full">
                    <div className="max-w-screen-lg 2xl:max-w-screen-xl mx-auto px-4 py-6 pl-4 md:pl-12 lg:pl-4 text-white">
                        <nav className='text-sm flex items-center gap-4'>
                            <a href="/" className='after:content-["."] after:ml-4 after:transition-all after:duration-200 last-of-type:after:hidden transition-all duration-200 hover:text-black hover:after:text-white'>
                                Home
                            </a>

                            {breadcrumb.map((item, index) => (
                                <a href={`/${item.slug}`} key={index} className='after:content-["."] after:ml-4 after:transition-all after:duration-200 last-of-type:after:hidden transition-all duration-200 hover:text-black hover:after:text-white'>
                                    {item.name}
                                </a>
                            ))}
                        </nav>

                        <h2 className="text-white text-2xl lg:text-4xl mt-4 md:mt-6 lg:mt-10 2xl:mt-14 max-w-64 md:max-w-none">
                            {title}
                        </h2>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
